import React from 'react';
import { Icon } from '@chakra-ui/react';
import { Logo as LogoIcon } from './icons';

const Logo = props => {
  return <Icon height={'none'} as={LogoIcon} color="primary" {...props} />;
};

export default Logo;
